<roots-page-header
  [toolTip]="toolTip"
  [title]="title"
  [loading]="loading"
  [items]="actionButtons"
  (refresh)="refresh()"
  (actionListClicked)="actionsClicked($event)"
  >
</roots-page-header>
<section class="roots-table-card manufacturing-table-card">
  <mat-table
    #sort="matSort"
    matSort
    [dataSource]="dataSource"
    >
    <ng-container matColumnDef="type">
      <mat-header-cell *matHeaderCellDef class="center w-20" mat-sort-header>
        Acknowledge
      </mat-header-cell>
      <mat-cell *matCellDef="let log">
        <button mat-button type="button" class="validation-button"
          [class.is-validated]="log.validatedBy !== null" [class.is-pending]="log.validatedBy === null"
          (click)="dialog(log)" matTooltip="Click to validate unit"
          [attr.aria-label]="log.type + ': ' + (log.validatedBy !== null ? 'Validated' : 'Pending validation') + '. Open validation dialog'">
          <mat-icon>{{ log.validatedBy !== null ? 'check_circle' : 'schedule' }}</mat-icon>
          {{ log.type }} · {{ log.validatedBy !== null ? 'Validated' : 'Pending' }}
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>View Log Details</mat-header-cell>
      <mat-cell *matCellDef="let log">
        <button mat-button type="button" class="log-name-button" (click)="navigateToLogDetail(log)"
          matTooltip="View logs for: {{ log.name }}">{{ log.name }}</button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="generate">
      <mat-header-cell *matHeaderCellDef class="center" mat-sort-header><span class="create-assets-heading">Create Assets</span></mat-header-cell>
      <mat-cell *matCellDef="let log" class="center">
        <button mat-icon-button type="button" class="generate-assets-button" (click)="generate(log)"
          matTooltip="Generate assets from Log" [attr.aria-label]="'Generate assets from ' + log.name">
          <mat-icon>devices</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="modelNumber">
      <mat-header-cell *matHeaderCellDef class="center w-10" mat-sort-header>
        Model Number
      </mat-header-cell>
      <mat-cell *matCellDef="let log" class="table-overflow center w-10">
        @if (log.modelNumber) {
          <span class="model-number">{{ log.modelNumber }}</span>
        } @else {
          <span class="missing-value">N/A</span>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="voltage">
      <mat-header-cell *matHeaderCellDef class="center w-10" mat-sort-header>
        <!-- <i class="material-icons log-icon" style="color: yellow">flash_on</i> -->
        Voltage
      </mat-header-cell>
      <mat-cell *matCellDef="let log" class="table-overflow center w-10">
        {{ log.voltage}}
      </mat-cell>
    </ng-container>


    <ng-container matColumnDef="time">
      <mat-header-cell *matHeaderCellDef class="center" mat-sort-header>
        Time
      </mat-header-cell>
      <mat-cell *matCellDef="let log" class="table-overflow center">
        {{ log.time | date: 'short' }}
      </mat-cell>
    </ng-container>


    <!-- <ng-container matColumnDef="number">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="w-10">
      #
    </mat-header-cell>
    <mat-cell *matCellDef="let log" class="table-overflow w-10">
      {{ log.sensors.length }}
    </mat-cell>
  </ng-container> -->

  <ng-container matColumnDef="validatedBy">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      Validated By
    </mat-header-cell>
    <mat-cell *matCellDef="let log" class="table-overflow">
      {{ log.validatedBy || '—' }}
    </mat-cell>
  </ng-container>


  <ng-container matColumnDef="sensors">
    <mat-header-cell class="center w-20" *matHeaderCellDef mat-sort-header>
      Sensors
    </mat-header-cell>
    <mat-cell
      *matCellDef="let log"
      class="table-overflow center w-20"
      >
      <button mat-button type="button" class="sensor-count-button" [matMenuTriggerFor]="menu"
        [attr.aria-label]="'View ' + log.sensors.length + ' sensors for ' + log.name">{{log.sensors.length}}</button>
      <!-- #enddocregion mat-menu-trigger-for -->
      <mat-menu #menu="matMenu">
        @for (sensor of log.sensors |  sort:'port'; track sensor) {
          <button style="min-width: fit-content;"
            mat-menu-item [ngStyle]="{'background-color': sensor.testSensor? '#eed202' : ''}"
          >Port {{sensor.port}}: {{ sensor.name }} </button>
        }
      </mat-menu>
      <!-- <div class="col-6"
      *ngFor="let sensor of log.sensors">
      {{ sensor.name }}
    </div> -->
  </mat-cell>
</ng-container>


<!-- <ng-container matColumnDef="edit">
<mat-header-cell class="align-mid" *matHeaderCellDef>
  Details
</mat-header-cell>
<mat-cell class="align-right" *matCellDef="let log">
  <button
    mat-icon-button
    color="warn"
    (click)="navigateToLogDetail(log)"
    matTooltip="View Log's Details"
    matTooltipPosition="above"
    >
    <mat-icon class="mat-18">reorder</mat-icon>
  </button>
</mat-cell>
</ng-container> -->

<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
<mat-row *matRowDef="let row; columns: displayedColumns"
  [ngClass]="{'highlight': selectedRowIndex == row.id}"
  (click)="highlight(row)">
</mat-row>
</mat-table>

<div class="roots-table-footer">
  <mat-paginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20, 50]">
  </mat-paginator>
</div>
</section>
